import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { AmbientOrbs } from "./Ambient";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { ARTICLES } from "@/lib/data";

export const KnowledgeCentre = () => (
  <section id="blog" className="relative overflow-hidden bg-[rgb(238,242,250)] py-16 md:py-20" data-testid="knowledge-section">
    <AmbientOrbs />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <Reveal>
            <span className="inline-flex items-center rounded-full border border-emerald2-300/40 bg-emerald2-500/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-emerald2-600">
              Knowledge Centre
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-navy-900 md:text-4xl lg:text-5xl">
              Insights, updates and guides
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <Link
            to="/blogs"
            data-testid="knowledge-view-all"
            className="inline-flex items-center gap-1.5 rounded-full border border-navy-900/15 bg-white px-5 py-2.5 text-sm font-semibold text-navy-900 transition-colors hover:border-gold-400 hover:text-gold-600"
          >
            View all articles <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <Carousel opts={{ align: "start", loop: true }} className="mt-14" data-testid="knowledge-carousel">
          <CarouselContent>
            {ARTICLES.map((a, i) => (
              <CarouselItem key={a.title} className="md:basis-1/2 lg:basis-1/3" data-testid={`article-card-${i}`}>
                <Link
                  to="/blogs"
                  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-[0_20px_44px_rgba(15,30,60,0.12)]"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={a.img}
                      alt={a.title}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                      loading="lazy"
                    />
                    <span className={`absolute left-4 top-4 rounded-full px-3 py-1 text-xs font-semibold backdrop-blur ${i % 2 === 0 ? "bg-navy-900/90 text-gold-400" : "bg-emerald2-600/95 text-white"}`}>
                      {a.tag}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <h3 className="text-lg font-semibold leading-snug text-navy-900 transition-colors group-hover:text-gold-600">
                      {a.title}
                    </h3>
                    <div className="mt-auto flex items-center gap-2 pt-5 text-xs font-medium text-slate-500">
                      <Clock className="h-3.5 w-3.5" /> {a.read}
                    </div>
                  </div>
                </Link>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-8 flex items-center justify-center gap-3">
            <CarouselPrevious className="static h-10 w-10 translate-y-0" data-testid="knowledge-prev" />
            <CarouselNext className="static h-10 w-10 translate-y-0" data-testid="knowledge-next" />
          </div>
        </Carousel>
      </Reveal>
    </div>
  </section>
);
